import { render, staticRenderFns } from "./historicoacademico.vue?vue&type=template&id=f9728f66&"
import script from "./historicoacademico.vue?vue&type=script&lang=js&"
export * from "./historicoacademico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports